import Modal from 'components/Modals/presets/BasicModal';
import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

export const AdminFailureModal = (props: any) => {
  const { lockDate, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Modal
      size="small"
      {...rest}
      heading={t('Payment Attempts Failed')}
      buttonText={t('Billing Settings')}
      actionBtnColor="blue"
      defaultLeftBtnText={t('Close')}
    >
      <div className="pb-2">
        {lockDate ? (
          <Typography>
            {t(
              'Your payment has failed 3 times, and your account will be suspended unless paid by {{lockDate}}. Update your billing settings to ensure uninterrupted service.',
              {
                lockDate: lockDate.toLocaleDateString(),
              }
            )}
          </Typography>
        ) : (
          // We should always have a lock date in this state, but if we don't for some reason let's still try
          // to handle it gracefully and show something useful.
          <Typography>
            {t(
              'Your payment has failed 3 times, and your account will be suspended unless paid immediately. Update your billing settings to ensure uninterrupted service.'
            )}
          </Typography>
        )}
      </div>
    </Modal>
  );
};

export const UserFailureModal = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      size="small"
      {...props}
      heading={t('Payment Attempts Failed')}
      buttonText={t('Confirm')}
      actionBtnColor="blue"
      leftBtn={null}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'Your account is at risk of suspension due to failed payment attempts. Contact your administrator to ensure uninterrupted service.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
